import React, { PureComponent } from 'react';
import styled from 'styled-components';
import ComponentTitle from './ComponentTitle';
import UpdatedDate from './UpdatedDate';

const StyledMissingComponent = styled.div`
  grid-column: span 12;
  @media (min-width: 1280px) {
    grid-column: span ${props => props.columns};
  }
`;

const StyledMissingPlotWrapper = styled.div`
  border-radius: 5px;
  background: white;
  padding: 10px 10px 35px 10px;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(38, 47, 51, 0.3);
  overflow: hidden;
`;

const MissingPlot = styled.div`
  color: #42515a;
  box-sizing: border-box;
  padding: 30px;
  width: 100%;
  ${props => {
    if (!props.heightInPx) {
      props.heightInPx = 500;
    }
    if (props.columns === 12) {
      if (props.heightInPx > 500) {
        return `height: 500px;`;
      } else {
        return `height: ${props.heightInPx}px;`;
      }
    } else {
      if (props.heightInPx > 500) {
        return `height: 500px;
        @media (min-width: 1280px) {
            height: ${props.heightInPx}px;
        }`;
      } else {
        return `height: ${props.heightInPx}px;`;
      }
    }
  }} display: grid;
  justify-items: center;
  align-items: center;
  align-content: center;
`;

class MissingComponent extends PureComponent {
  render() {
    const {
      title,
      info,
      missingText,
      columns,
      heightInPx,
      lastUpdated
    } = this.props;
    return (
      <StyledMissingComponent columns={columns}>
        <ComponentTitle title={title} info={info} />
        <StyledMissingPlotWrapper>
          <MissingPlot
            columns={columns}
            heightInPx={heightInPx}
            dangerouslySetInnerHTML={{ __html: missingText }}
          />
          <UpdatedDate>{`letztes Update: ${lastUpdated}`}</UpdatedDate>
        </StyledMissingPlotWrapper>
      </StyledMissingComponent>
    );
  }
}

export default MissingComponent;
